const ENTORNO_APUYEN = {
    BaseURL: 'https://desarrollofront.pwgs.app/modulos/pwgsapi/index.php/'
}

export {
    ENTORNO_APUYEN
}
